import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  ActionApiResponse,
  ShareVehicleInviteResponse,
  ShareVehicleInviteUserLookupResponse,
  ShareVehicleMemberResponse,
  vehicleShareResponse,
} from '../../../models/member.model';

@Injectable({
  providedIn: 'root',
})
export class ApiVehicleShareService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(private http: HttpClient) {}

  private jsonHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  getVehicleShare(uid: string): Observable<vehicleShareResponse[]> {
    const url = this.tokenUrl + '/Cityparking/getVehicleShare';
    const params = new HttpParams().set('uid', uid);
    return this.http.get<vehicleShareResponse[]>(url, {
      headers: this.jsonHeaders(),
      params,
    });
  }

  getVehicleShareDetails(
    uid: string,
    groupId: number
  ): Observable<ShareVehicleMemberResponse[]> {
    const url = this.tokenUrl + '/Cityparking/getVehicleShareDetails';
    const params = new HttpParams()
      .set('uid', uid)
      .set('groupId', groupId.toString());
    return this.http.get<ShareVehicleMemberResponse[]>(url, {
      headers: this.jsonHeaders(),
      params,
    });
  }

  getInvitesSent(
    uid: string,
    status?: string
  ): Observable<ShareVehicleInviteResponse[]> {
    const url = this.tokenUrl + '/Cityparking/getShareVehicleInvitesSent';
    let params = new HttpParams().set('uid', uid);
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<ShareVehicleInviteResponse[]>(url, {
      headers: this.jsonHeaders(),
      params,
    });
  }

  getInvitesInbox(
    uid: string,
    status?: string
  ): Observable<ShareVehicleInviteResponse[]> {
    const url = this.tokenUrl + '/Cityparking/getShareVehicleInvitesInbox';
    let params = new HttpParams().set('uid', uid);
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<ShareVehicleInviteResponse[]>(url, {
      headers: this.jsonHeaders(),
      params,
    });
  }

  findUserByPhone(
    uid: string,
    phone: string
  ): Observable<ShareVehicleInviteUserLookupResponse> {
    const url = this.tokenUrl + '/Cityparking/getShareVehicleInviteUserByPhone';
    const params = new HttpParams().set('uid', uid).set('phone', phone);
    return this.http.get<ShareVehicleInviteUserLookupResponse>(url, {
      headers: this.jsonHeaders(),
      params,
    });
  }

  inviteShareVehicle(payload: {
    uid: string;
    vehicleId: number;
    toCpUserId?: number;
    toPhone?: string;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/inviteShareVehicle',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  acceptInvite(payload: {
    uid: string;
    inviteId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/acceptShareVehicleInvite',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  rejectInvite(payload: {
    uid: string;
    inviteId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/rejectShareVehicleInvite',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  cancelInvite(payload: {
    uid: string;
    inviteId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/cancelShareVehicleInvite',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  revokeMember(payload: {
    uid: string;
    groupId: number;
    cpUserId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/revokeShareVehicleMember',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  leaveShare(payload: {
    uid: string;
    groupId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/leaveShareVehicle',
      payload,
      { headers: this.jsonHeaders() }
    );
  }

  dissolveGroup(payload: {
    uid: string;
    groupId: number;
  }): Observable<ActionApiResponse> {
    return this.http.post<ActionApiResponse>(
      this.tokenUrl + '/Cityparking/dissolveShareVehicleGroup',
      payload,
      { headers: this.jsonHeaders() }
    );
  }
}
